export const INCHES_IN_FOOT = 12;
export const MM_IN_INCH = 25.4;

export const mmToFeetInches = (mm?: number | null) => {
  if (!mm) return mm;

  const totalInches = mm / MM_IN_INCH;
  const ft = Math.floor(totalInches / INCHES_IN_FOOT);
  const inches = Math.round(totalInches % INCHES_IN_FOOT);

  return { ft, in: inches };
};

type TFeetInchesToMm =
  | {
      ft?: number;
      in?: number;
    }
  | undefined
  | null;
export const feetInchesToMm = (data: TFeetInchesToMm) => {
  if (!data) return data;

  const { ft = 0, in: inches = 0 } = data;
  const mm = Math.round((ft * INCHES_IN_FOOT + inches) * MM_IN_INCH);

  return mm;
};

export const mmToFeetInchesString = (mm?: string) => {
  const parsedMm = typeof mm === 'string' ? parseFloat(mm) : mm;
  if (!parsedMm || Number.isNaN(parsedMm)) return '';

  const totalInches = parsedMm / MM_IN_INCH;
  const ft = Math.floor(totalInches / INCHES_IN_FOOT);
  const inches = Math.round(totalInches % INCHES_IN_FOOT);

  return `${ft}ft ${inches}in`;
};
